import React from 'react';

export const withLayout = ({layoutComponent: LayoutComponent, component: Component}) => (props: any) => (
    <LayoutComponent {...props}>
        <Component {...props} />
    </LayoutComponent>
);
